(ns practitest.frontend.components2.entity-form.fields
  (:require
    [ajax.core :as ajax]
    [cljs.reader]
    [clojure.set]
    [clojure.string :as str]
    [goog.object]
    [practitest.frontend.common-entities.metadata :refer [entities-metadata
                                                          get-entity-name]]
    [practitest.frontend.common.dom :as dom]
    [practitest.frontend.common.format-utils :as fu]
    [practitest.frontend.common.i18n :refer [get-translation]]
    [practitest.frontend.components.datepicker :as datepicker]
    [practitest.frontend.components.datepicker2 :as datepicker2]
    [practitest.frontend.components.forms :as forms1]
    [practitest.frontend.components.markdown :as markdown]
    [practitest.frontend.components.notifications :as notifications]
    [practitest.frontend.components.overflow :as overflow]
    [practitest.frontend.components.selector :as selector2]
    [practitest.frontend.components.users :as users]
    [practitest.frontend.components2.entity-form.base-control :refer [base-control]]
    [practitest.frontend.components2.entity-form.folder-input :refer [folder-input]]
    [practitest.frontend.components2.entity-form.jira-user-list-input :refer [jira_user_list]]
    [practitest.frontend.components2.run-status :as run-status2]
    [practitest.frontend.events :as events]
    [practitest.frontend.folders :as folders]
    [practitest.frontend.kanban :as kanban]
    [practitest.frontend.routing.backend-routes :as broutes]
    [practitest.frontend.subs :as subs]
    [re-frame.core :as re-frame]
    [reagent.core :as reagent]))

;; Taking two first letters and capitalizing them
;; e.g.
;; "Administrators" -> "A"
;; "Team 7" -> "T7"
;; "Our Very Brave Testers" -> "OV"
(defn- group-name->initials
  [name]
  (when name
    (str/join (map (comp first str/capitalize)
                   (take 2 (str/split name #"\s"))))))

(defn group-avatar
  [group]
  (let [name (:name group)]
    [:div.avatar-holder.group-avatar
     [:span.new-avatar-icon.group-avatar
      (group-name->initials name)]]))

(defn user-item-renderer
  [{:keys [selected? hover? on-hover on-change label-fn inner-ref item multi?]}]
  (let [type (:type item)
        name (:name item)
        id (:id item)
        avatar (:avatar item)]
    [:div.selector-item
     {:class         (dom/classes-pairs :active selected?
                                        :hover hover?)
      :ref           inner-ref
      :on-mouse-over on-hover
      :on-mouse-move on-hover
      :on-click      (fn [e]
                       (when on-change
                         (on-change item)))}

     (case type
       "group"
       [group-avatar item]

       "user"
       [users/user-avatar2 item]

       ;; else
       nil)

     [overflow/overflow-with-mux-tooltip
      {}
      (fn [props]
        [:span.selector-item-text
         props
         name])
      name]]))

(defn selected-user-renderer
  [{:keys [show? value label-fn]}]
  [:div.selector-current-item
   {:class (dom/classes-pairs :expanded show?)}
   (when-let [name (:name value)]
     [:<>
      [users/user-avatar2 value]

      [overflow/overflow-with-mux-tooltip
       {}
       (fn [props]
         [:span.selector-item-text
          props
          name])
       name]])])

(defn- update-field-state
  [{:keys [get-field-state
           set-field-state
           field-id]
    :as   field-props} update-fn & params]
  (set-field-state field-id (apply update-fn @(get-field-state field-id) params)))

(defn- reset-field-state
  [{:keys [set-field-state
           reconcile-form
           field-id]
    :as   field-props}]
  (set-field-state field-id nil)
  (reconcile-form))

(defn- set-field-value
  [{:keys [validators]
    :as   field-props}
   new-value]

  (update-field-state field-props
                      assoc
                      :value new-value
                      :dirty? true
                      :errors (forms1/validate-all validators new-value)))

;; Base control - both for edit and create modes

(defn- update-field-definition
  [db data]
  ;; TODO: get rid of empty vector
  (let [field (events/convert-field [] data)]
    (assoc-in db [:fields (:name field)] field)))

(defn added-list-value [{db :db} [_ field-props value response]]
  {:db         (-> db
                   (update :progress disj ::add-list-value)
                   (update-field-definition (:data response)))
   :dispatch-n [[::notifications/success2
                 (get-translation "testset.notification.new-list-value-added" "New list value added")
                 {:auto-close 1000}]
                ;; Select new value in list
                [::events/set-field-value (:entity-type field-props) (:name field-props) value]]})

(re-frame/reg-event-fx
 ::added-list-value
 added-list-value)

(defn add-list-value [{db :db}
                      [_ field-props value]]
  {:db (update db :progress conj ::add-list-value)
   :http-xhrio
   {:method          :post
    :uri             (let [path-params {:project_id (subs/get-current-project-id db)
                                        :p_id       (subs/get-current-project-id db)
                                        :id         (:id field-props)}]
                       (if (:system? field-props)
                         (broutes/get-url "system_fields#add_list_value2" path-params)
                         (broutes/get-url "custom_fields#add_list_value2" path-params)))

    :params          {:value value}
    :format          (ajax/json-request-format)
    :response-format (ajax/json-response-format {:keywords? true})

    :on-success      [::added-list-value field-props value]
    :on-failure      [::events/api-error ::add-list-value
                      {:message (get-translation "testset.notification.new-list-value-error" "Error adding new list value")}]}})

(re-frame/reg-event-fx
 ::add-list-value
 add-list-value)

(defn on-add-value
  [field-props value]
  (let [tags? (:tags? field-props)
        value (if tags?
                value
                (js/prompt "Enter new field value"))
        value (fu/validate-new-list-value! value)]
    (when value
      (if tags?
        (re-frame/dispatch [::add-tags (set [value])])
        (re-frame/dispatch [::add-list-value field-props value])))))

(defn base-list-control
  [{:keys [clear-linked-lists

           field-id
           errors
           type
           multi?
           value
           add?

           tags?

           possible-values

           mandatory?

           label-fn
           key-fn

           list-transitions
           base-value

           on-change]
    :as   props}]
  [base-control
   props
   ;; Selector view
   [selector2/new-select {:items                  (if (seq list-transitions)
                                                    ;; We're assuming that those are labels here
                                                    ;; Filter possible values according to transitions array
                                                    (let [possible-transitions (->> list-transitions
                                                                                    (filter #(= (label-fn base-value) (ffirst %)))
                                                                                    (map #(second (first %)))
                                                                                    (set))]
                                                      (filter #(or (contains? possible-transitions (label-fn %))
                                                                   ;; Include base value as well
                                                                   (= base-value %)) possible-values))
                                                    possible-values)
                          :id                     field-id
                          :label-fn               label-fn
                          :key-fn                 key-fn

                          :selector-item-renderer (when (= :user type)
                                                    user-item-renderer)
                          :selected-item-renderer (when (= :user type)
                                                    selected-user-renderer)

                          :placeholder            (get-translation "generic.list.placeholder" "Select value")
                          :clearable?             (not mandatory?)

                          :on-add-value           (when add?
                                                    (fn [item]
                                                      (on-add-value props item)))
                          :multi?                 multi?
                          :tags?                  tags?
                          :class                  (dom/classes-pairs :errors (seq errors))

                          :value                  value
                          :on-change              (fn [value]
                                                    (when on-change
                                                      (on-change value))

                                                    (when clear-linked-lists
                                                      (clear-linked-lists field-id)))}]
   ;; Readonly view
   [:span
    ;; TODO: something more sophisticated ?
    (when (= :run_status field-id)
      [:span.run-status-color {:style {:background (run-status2/get-status-color (:id value))}}])
    (if multi?
      (str/join ", " (map label-fn value))
      (label-fn value))]])

(defn text-input
  [{:keys [type
           value
           edit?
           errors
           ref
           field-id
           placeholder
           max-length
           autofocus?
           on-blur]
    :as   field-props}]
  [:input.m-input
   {:ref         (fn [node]
                   (when ref
                     (ref node)))
    :placeholder placeholder
    :id          field-id
    :class       (dom/classes-pairs :errors (seq errors))
    :type        (case type
                   :number "number"
                   ;; else
                   "text")
    :value       value
    :max-length  max-length
    :autoFocus   (boolean autofocus?)
    :on-blur     on-blur
    :on-change   (fn [e]
                   (set-field-value field-props (dom/event-value e)))}])

(defn checkbox-control-editing
  [{:keys [value
           errors
           ref
           field-id
           on-change]
    :as   field-props}]
  [:input.m-checkbox.m-entity-checkbox
   {:ref       (fn [node]
                 (when ref
                   (ref node)))
    :id        field-id
    :class     (dom/classes-pairs :errors (seq errors))
    :type      "checkbox"
    :checked   (if (= "yes" value)
                 true
                 false)
    :on-change on-change}])

(defn url-field
  [{:keys [value
           read-only?
           class]
    :as field-props}]
  (cond
    (string? value)
    [:a {:href value
         :title value
         :on-click (fn [e]
                     (dom/stop-propagation e))
         :class (str (dom/classes-pairs-v :m-readonly-field read-only?) " " class)
         :target "_BLANK"}
     value]

    (map? value)
    (let [url (:url value)
          title (:title value)]
      [:a {:href url
           :title url
           :on-click (fn [e]
                       (dom/stop-propagation e))
           :class (str (dom/classes-pairs-v :m-readonly-field read-only?) " " class)
           :target "_BLANK"}
       title])))

(defn checkbox-control-readonly
  [{:keys [type
           value
           read-only?
           errors
           ref
           field-id]
    :as   field-props}]
  [:input.m-checkbox.m-readonly-checkbox
   {:ref       (fn [node]
                 (when ref
                   (ref node)))
    :id        field-id
    :class     (dom/classes-pairs :errors (seq errors))
    :type      "checkbox"
    :checked   (if (= "yes" value)
                 true
                 false)
    :on-change (fn [e])}])

(re-frame/reg-event-db
 ::add-tags
 (fn [db [_ new-tags]]
   (update db :tags
           (fn [existing-tags]
              ;; TODO: fix this, so ugly
             (let [etags (set (map first existing-tags))
                   ntags (clojure.set/difference new-tags etags)]
                ;; only add new tags here
               (apply conj existing-tags
                      (map #(vector % 0) ntags)))))))

(defn- memo-on-drag-over [local-state e]
  (set! (.-dropEffect (.-dataTransfer e)) "copy")
  (dom/prevent-default e)
  (swap! local-state assoc :dragged-over? true))

(defn- memo-on-drag-leave [local-state e]
  (dom/prevent-default e)
  (swap! local-state assoc :dragged-over? false))

(defn- memo-on-drop [local-state field-info on-files-attached e]
  (dom/prevent-default e)

  (swap! local-state assoc :dragged-over? false)

  (let [files (.-files (.-dataTransfer e))]
    (when (and on-files-attached
               ;; Only trigger event if there are actual files dropped
               (seq files))
      (on-files-attached field-info files))))

;; TODO: fix this on backend
(defn try-parse-multilist-value [raw-multilist-string]
  (when (string? raw-multilist-string)
    (try
      (if (str/starts-with? raw-multilist-string "[")
        ;; We're assuming here that multilist formatting is EDN-compatible
        (cljs.reader/read-string raw-multilist-string)
        ;; In some scenarios (like list -> multilist conversion)
        ;; It's possible that we have simple "string" as single element
        [raw-multilist-string])
      (catch js/Error e
        (js/console.warn e)))))

(defn get-user-id [value]
  (when value
    ;; We can have various user representations
    (cond
      ;; It's a map with full user data
      (map? value)
      (:id value)

      (number? value)
      value

      ;; String can be of two types - just a number or something like "User-<id>"
      (string? value)
      (if (str/starts-with? value "User-")
        (fu/try-parse-number (str/replace-first value #"User-" ""))
        (fu/try-parse-number value))

      :else
      (js/console.warn "Unhandled case for user-id" (type value) value))))

(defn build-field
  [_ _]

  (let [local-state (reagent/atom {})
        textarea-ref (atom nil)]
    (fn [{:keys [field-name
                 edit-permissions? 
                 issue_type_id]
          :as   field-props}
         {:keys [set-field-state
                 get-field-state
                 get-field-props
                 get-form-state
                 new?
                 on-files-attached]
          :as   form-props}]
     
      (let [field-props @(get-field-props field-name)
            project @(re-frame/subscribe [::subs/current-project])

            {:keys [editing?
                    value
                    errors]
             :as   field-state} @(get-field-state field-name)

            {:keys [base-entity]
             :as   form-state} @(get-form-state)

            field (:field field-props)
            field-id (:field-id field-props)
            field-type (:type field-props)
            field-info {:textarea-ref textarea-ref
                        :field-id field-id}

            ;; Merge both form and field-props
            ;; TODO: cleanup a little bit
            props (merge form-props
                         field-props
                         {:value      value
                          :errors     errors
                          :read-only? (if edit-permissions?
                                        (:read-only? field-props)
                                        ;; Readonly fields if without permissions
                                        true)})]
        (case field-type
          :memo
          [base-control
           props
           [markdown/markdown-editor {:id field-id
                                      :value         value
                                      ;; Special case for description field
                                      :class         (dom/classes-pairs :description (= :description field-id))
                                      :on-change     (fn [value]
                                                       (set-field-value props value))
                                      :textarea-ref  textarea-ref
                                      :on-drag-over  (reagent/partial memo-on-drag-over local-state)
                                      :on-drag-leave (reagent/partial memo-on-drag-leave local-state)
                                      :on-drop       (reagent/partial memo-on-drop local-state field-info on-files-attached)}]
           [markdown/markdown-editor {:read-only? true
                                      :class    (dom/classes-pairs :description (= :description field-id))
                                      :value    value}]]

          :kanban_lane
          [base-list-control
           (assoc props :label-fn :name
                  :value (kanban/find-lane value (:possible-values props))
                  :key-fn (fn [lane idx]
                            (:lane_id lane))
                  :on-change (fn [value]
                               (set-field-value props value))
                  :simple? false)]

          :tags
          [base-list-control
           (assoc props :multi? true
                  :tags? true
                  :add? true
                  :label-fn :label
                  :value (set (map (fn [tag]
                                     {:id    tag
                                      :label tag})
                                   value))
                  :on-change (fn [tags]
                               (set-field-value props (set (map :id tags))))
                  :possible-values (mapv (fn [[tag count]]
                                           {:id    tag
                                            :label tag})
                                         (:possible-values props)))]
          ;; Lists are mostly the same, with slight differences
          :jira_user_list
          [jira_user_list
           (assoc props
                  :label-fn (or (:label-fn field-props) :label)
                  :key-fn (or (:key-fn field-props)
                              (fn [item idx]
                                (str idx "-" (:id item))))
                  :base-value (get base-entity field)
                  :external-id (:external_id base-entity)
                  :issue_type_id issue_type_id
                  :on-change (fn [base_value]
                               (let [id (:value base_value)
                                     label (:label base_value)]
                                 (set-field-value props (:id base_value)))))]

          (:multilist :list)
          (let [multi? (= :multilist field-type)
                ;; Special raw-list support - can override label-fn and key-fn and no possible values conversion
                raw-list? (:raw-list? field-props)
                label-fn (or (:label-fn field-props)
                             :label)
                key-fn (or (:key-fn field-props)
                           ;; Current DB has same values in multilist/lists and that messes up
                           ;; with default key-fn that uses :id, so we're using index here as well
                           (fn [item idx]
                             (str idx "-" (:id item))))
                no-value-label (str "( " (get-translation "grid.fast-filters.no-value" "No Value") " )")
                value-label (fn [v]
                              (if (str/blank? v)
                                no-value-label
                                v))
                possible-values (if raw-list?
                                  (:possible-values props)
                                  (map (fn [v]
                                         {:id    v
                                          :label (value-label v)})
                                       (:possible-values props)))
                value (if raw-list?
                        value
                        (if multi?
                          (set
                            ;; TODO: fix this multilist issue
                           (for [v (if (string? value)
                                     (try-parse-multilist-value value)
                                     value)]
                             {:id    v
                              :label (value-label v)}))
                          (when (some? value)
                            {:id    value
                             :label (value-label value)})))

                ;; Base value is in "entity-format" but we need it here in "form-format"
                base-value (get base-entity field)
                base-value (when (some? base-value)
                             {:id    base-value
                              :label base-value})]
            [base-list-control
             (assoc props :value value
                    :base-value base-value
                          ;:trace? true
                    :label-fn label-fn
                    :key-fn key-fn
                    :multi? multi?
                    :add? (and (not multi?)
                               (:allow-add-list-value? field-props))
                    :on-change (fn [value]
                                 (if raw-list?
                                   (set-field-value props value)
                                   (set-field-value props (if multi?
                                                                  ;; TODO: fix this
                                                            (js/JSON.stringify (clj->js (mapv :label value)))
                                                            (:label value)))))
                    :possible-values possible-values)])

          :linkedlist
          (let [parent-value (:value @(get-field-state (:parent_list_field_name props)))
                options (when parent-value
                          (get (:possible-values props) parent-value))
                current-value (when value
                                {:label value
                                 :id    value})]
            [base-list-control
             (assoc props :value current-value
                    :label-fn :label
                          ;; Same as for multilist - we allow duplicate values for now
                    :key-fn (fn [item idx]
                              (str idx "-" (:id item)))
                    :on-change (fn [value]
                                 (set-field-value props (:label value)))
                    :possible-values (map (fn [v]
                                            {:id    v
                                             :label v})
                                          options))])

          :user
          (let [user-id (get-user-id value)
                ;; Special assigned_to handling
                field-type (or (:type value) "user")

                ;; TODO: rework user handling between frontend and backend
                user (first (filter #(and (= (:type %) field-type)
                                          (= (:id %) user-id))
                                    (:possible-values props)))]

            [base-list-control
             (assoc props :label-fn :name
                    :value user
                    :on-change (fn [user]
                                 (set-field-value props user))
                    :key-fn (fn [user idx]
                              (str (:type user) "-" (:id user))))])

          :folder_id
          [base-control
           props
           [folder-input
            (assoc props
                   :folder-id value
                   :on-change (fn [folder-id]
                                (set-field-value props folder-id)))]
           (when-let [folder (folders/find-folder value (:possible-values props))]
             (:label folder))]

          :checkbox
          [base-control
           props
           [checkbox-control-editing
            (assoc props
                   :on-change (fn [e]
                                (set-field-value props (if (dom/event-value e)
                                                         "yes"
                                                         "no"))))]
           [checkbox-control-readonly props]]

          (:text :url :number)
          [base-control
           props
           ;; editing control
           [text-input props]
           ;; readonly control
           (if (= :url field-type)
             [url-field (assoc props :class "ellipsis")]
             value)]

          :milestone
          (let [key-fn (or (:key-fn field-props)
                           (fn [item idx]
                             (str idx "-" (:id item))))
                possible-values (map (fn [v]
                                       {:id    (first v)
                                        :label (last v)})
                                     (:possible-values props))
                value (when (some? value)
                        {:id    (:id value)
                         :label (:label value)})]
            [base-list-control
             (assoc props :value value
                    :label-fn :label
                    :key-fn key-fn
                    :on-change #(set-field-value props {:id (:id %)
                                                        :label (:label %)})
                    :possible-values possible-values)])

          (:linked_milestones :milestones)
          [base-list-control
           (assoc props :multi? true
                  :label-fn :label
                  :possible-values (map (fn [i]
                                          (let [[id label] i]
                                            {:label label :id id}))
                                        (get-in props [:all-fields :milestone_id :possible-values]))
                  :on-change (fn [value]
                               (set-field-value props (map
                                                       #(vector (:id %) (:label %))
                                                       value)))
                  :value (into #{}  (map (fn [[id label]]
                                           {:id id :label label}) value)))]

          :date
          [base-control
           props
           [datepicker2/date-picker-input
            (assoc props :class (dom/classes-pairs :m-input true
                                                   :errors (seq errors))
                   :id field-id
                   :time? false
                   :on-change (fn [e]
                                (set-field-value props e)))]
           (fu/formatted-local-date value)]

          :date-time
          [base-control
           props
           [datepicker/instant-picker
            (assoc props :class "form-control m-input"
                   :field-id field-id
                   :on-change (fn [e]
                                (set-field-value props e)))]
           (fu/formatted-date-time value)]

          :duration
          [base-control
           props
           [text-input props]
           value]

          ;; default
          [:pre
           (with-out-str
             (println "field" name)
             (cljs.pprint/pprint field-props))])))))
             ;(println "props")
             ;(cljs.pprint/pprint props)


(defn go-to-component [entity]
  (let [value (reagent/atom "")
        jump-to-url (get-in entities-metadata [entity :urls :jump-to])
        placeholder (get-translation
                     (str (name entity) ".grid.go-to")
                     (str "Go to" " " (get-entity-name entity :plural-name)))]
    (fn [_]
      [:div.col-2.offset-4 {:style {:display :flex}}
       [:input.m-input.ellipsis
        {:placeholder placeholder
         :aria-label placeholder
         :type       :text
         :value @value
         :on-change (fn [e]
                      (reset! value (dom/event-value e)))
         ; TODO: Find alternative for react 18+, onKeyPress is deprecated
         :on-key-press
         (fn [e]
           (when (and (= (.-key e) "Enter")
                      (> (count @value) 0))
             (dom/post-navigate! (broutes/get-url jump-to-url
                                                  {:p_id (:id @(re-frame/subscribe [::subs/current-project]))}
                                                  {:display_id @value}))))}]])))
